import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/shared/ui/dialogs/ConfirmDialog';
import { useEntityDelete } from '@/shared/hooks/useEntityDelete';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiWarehouseProductDelete } from '@/entities/warehouse';
import type { ApiWarehouseProductItem } from '@/shared/types/api/warehouse';

type Props = {
  product: ApiWarehouseProductItem | null;
  onClose: () => void;
};

export const FeaturesWarehouseDeleteDialog = ({ product, onClose }: Props) => {
  const { t } = useTranslation();

  const remove = useEntityDelete({
    api: (id: string) => apiWarehouseProductDelete(id),
    invalidateKeys: [queryKeys.warehouseProducts.all],
    successKey: 'warehouse.delete.toast.deleted',
    onSuccess: onClose,
  });

  return (
    <ConfirmDialog
      open={Boolean(product)}
      title={t('warehouse.delete.title')}
      description={t('warehouse.delete.description', { trekId: product?.trek_id ?? '' })}
      confirmLabel={t('warehouse.delete.confirm')}
      cancelLabel={t('common.cancel')}
      confirmVariant="danger"
      loading={remove.isPending}
      onConfirm={() => product && remove.mutate(product.id)}
      onCancel={onClose}
    />
  );
};
